import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  banners: [],
  cacheMeta: {
    fetchedAt: 0,
    locationKey: ''
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
